import React, { useEffect, useState } from "react";
import SelectSiteHeader from "src/components/layout/SelectSiteHeader";
import Header from "src/components/layout/Header";
import { BaseButton } from "src/components/ui/baseButton";
import { Text } from "src/components/ui/Text";
import { DapSiteMap, DempSiteMap } from "./siteMap";
import { useNavigate, useSearchParams } from "react-router-dom";

function SiteMainPage() {
  const navigate = useNavigate();
  const [isDempSiteMap, setIsDempSiteMap] = useState(true);
  const [isRiskSiteMap, setIsRiskSiteMap] = useState(false);
  const [searchParams] = useSearchParams();
  const mapType = searchParams.get("map");

  useEffect(() => {
    if (mapType === "dap") {
      setIsDempSiteMap(false);
    } else if (mapType === "risk") {
      setIsRiskSiteMap(true);
    } else {
      navigate(`?map=demp`);
      setIsDempSiteMap(true);
    }
  }, [mapType, navigate]);

  return (
    <>
      <Header pageTitle="Site Management" showSubMenu={false}>
        <SelectSiteHeader />
      </Header>

      <div className="flex flex-col gap-3 mx-6 my-3">
        {/* Button Select Site Map */}
        <div className="flex gap-3 justify-between items-center">
          <div>
            <Text variant="bold-16" color="black">
              {isDempSiteMap && !isRiskSiteMap
                ? "DEMP Site Map"
                : isRiskSiteMap
                ? "Risk Map"
                : "DAP Site Map"}
            </Text>
          </div>

          {/*      */}
          <div className="flex gap-2">
            {/* {!isDempSiteMap && !isRiskSiteMap && (
              <BaseButton
                variant="primary"
                size="small"
                onClick={() => {
                  const siteMapType = "risk";
                  navigate(`?map=${siteMapType}`);
                  setIsRiskSiteMap(!isRiskSiteMap);
                }}
                className="!min-w-[80px] rounded-md"
              >
                Risk Map
              </BaseButton>
            )} */}

            {!isDempSiteMap && (
              <BaseButton
                variant="primary"
                size="small"
                onClick={() => {
                  const siteMapType = "demp";
                  navigate(`?map=${siteMapType}`);
                  setIsDempSiteMap(true);

                  if (isRiskSiteMap) {
                    setIsRiskSiteMap(false);
                  }
                }}
                className="!min-w-[80px] rounded-md"
              >
                {"DEMP Map"}
              </BaseButton>
            )}

            {(isDempSiteMap || isRiskSiteMap) && (
              <BaseButton
                variant="primary"
                size="small"
                onClick={() => {
                  const siteMapType = "dap";
                  navigate(`?map=${siteMapType}`);
                  setIsDempSiteMap(false);

                  if (isRiskSiteMap) {
                    setIsRiskSiteMap(false);
                  }
                }}
                className="!min-w-[80px] rounded-md"
              >
                {"DAP Map"}
              </BaseButton>
            )}
          </div>
        </div>

        {/* Site Map */}
        <div>
          {isDempSiteMap && !isRiskSiteMap ? (
            <DempSiteMap />
          ) : (
            <DapSiteMap isRiskSiteMap={isRiskSiteMap} />
          )}
        </div>
      </div>
    </>
  );
}

export default SiteMainPage;
